export class LoginError extends Error {
  code: string
  numAttemptsRemaining: number | string | null

  constructor(code: string, numAttemptsRemaining: number | string | null = null, ...params: string[]) {
    super(...params)
    this.code = code
    this.name = 'LoginError'
    this.numAttemptsRemaining = numAttemptsRemaining
  }
}
